var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "field",
    { attrs: { label: _vm.label, disabled: _vm.disabled, inline: _vm.inline } },
    [
      _c("dropdown-field", {
        attrs: {
          source: _vm.packageVersionSource,
          "text-field": "versionName",
          "value-field": "loanListId",
          "auto-assign": _vm.autoAssign,
          clearable: _vm.clearable,
          placeholder: _vm.placeholder,
        },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }